export default __webpack_public_path__ + "static/media/55.625391d0.png";